var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Student Union")]),_c('h4',[_vm._v("Coming soon..")])])
}]

export { render, staticRenderFns }